import styled from 'styled-components';

export default styled.div`
	display: flex;
	gap: var(--spacing-x-small);
	align-items: center;
	min-width: 0;
	.motif-icon {
		color: var(${({$color}) => `--${$color}-400`});
		flex-shrink: 0;
	}
`;
